import React from "react";
import { Button } from "../ui/button";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface Props {
  label: string;
  link: string;
  state?: object;
}
function BackButton({ label, link, state }: Props) {
  const navigate = useNavigate();
  return (
    <Button
      variant="link"
      className="flex justify-start w-max p-0  text-gray-500"
      onClick={() =>
        navigate(link, {
          state: state ? state : {},
        })
      }
    >
      <ChevronLeft />
      <div>{label}</div>
    </Button>
  );
}

export default BackButton;
